import { CashDownVariant, useCashDownVariant } from '../../../../baseDealActivity/baseDealContainer/hooks/useCashDownVariant';
import { CashDownDefermentRow } from './CashDownDefermentRow';
import { CashReceivedRow } from './CashReceivedRow';
import { DefaultCashDownRow } from './DefaultCashDownRow';

const CASH_DOWN_ROWS = {
    [CashDownVariant.CASH_RECEIVED]: CashReceivedRow,
    [CashDownVariant.DEFERMENT]: CashDownDefermentRow,
    [CashDownVariant.CASH_DOWN]: DefaultCashDownRow
};

export const CashDownRow = () => {
    const Row = CASH_DOWN_ROWS[useCashDownVariant()];

    return <Row />;
};
